export default function($) {
    $(document).ready(function(){
        $('.datepicker').datepicker({
            closeText: 'Fermer',
            prevText: 'Précédent',
            nextText: 'Suivant',
            currentText: "Aujourd'hui",
            monthNames: [
                'Janvier',
                'Février',
                'Mars',
                'Avril',
                'Mai',
                'Juin',
                'Juillet',
                'Août',
                'Septembre',
                'Octobre',
                'Novembre',
                'Décembre'
            ],
            monthNamesShort: [
                'Janv.',
                'Févr.',
                'Mars',
                'Avril',
                'Mai',
                'Juin',
                'Juil.',
                'Août',
                'Sept.',
                'Oct.',
                'Nov.',
                'Déc.'
            ],
            dayNames: [
                'Dimanche',
                'Lundi',
                'Mardi',
                'Mercredi',
                'Jeudi',
                'Vendredi',
                'Samedi'
            ],
            dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
            dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            weekHeader: 'Sem.',
            dateFormat: 'dd/mm/yy',
            language: 'fr',
            autoclose: true
        });

        $('.js-search-date-filter').change(function(e){
            var frDate = $(e.currentTarget).val()
            var propName = $(e.currentTarget).attr("name")
            
            var formattedDate = $.datepicker.formatDate("yy-mm-dd",$.datepicker.parseDate( "dd/mm/yy", frDate ))

            var currentUrl = window.location
            var url = new URL(currentUrl);
            url.searchParams.set(propName, formattedDate);
            var newUrl = url.href;

            window.location.replace(newUrl) // redirect
        });

        $('.js-search-post_type-filter').change(function(e){
            var customsets = Object.values(
                $('.js-search-post_type-filter').filter(function() {
                    return $(this).is( ":checked" )
                }).map(function() {
                    return $(this).val()
                })
            )
            customsets.splice(-2,2) // remove (in place) lenght and previous object keys

            var currentUrl = window.location
            var url = new URL(currentUrl);
            url.searchParams.delete('customset[]')
            // `url.searchParams.set` doesn't work for array
            for(var customset of customsets){
                url.searchParams.append("customset[]", customset)
            }
            var newUrl = url.href;

            window.location.replace(newUrl) // redirect
        });
    });
}
